// extracted by mini-css-extract-plugin
export default {"paragraph":"P_paragraph__07TUt","ellipsis":"P_ellipsis__pzble","hover":"P_hover__0YY01"};